import { gql, useQuery } from '@apollo/client';
import { MODULE_FRAGMENTS, COMPONENT_FRAGMENTS } from './fragments';

const GET_SPLIT_VIEW = gql`
  ${COMPONENT_FRAGMENTS.IMAGE}
  ${COMPONENT_FRAGMENTS.CTA}
  ${COMPONENT_FRAGMENTS.STAT_CARD}
  ${COMPONENT_FRAGMENTS.CTA_CARD}
  ${COMPONENT_FRAGMENTS.CONTENT_TILE}
  ${MODULE_FRAGMENTS.TILE_CAROUSEL}
  ${MODULE_FRAGMENTS.ACCORDION}
  ${MODULE_FRAGMENTS.QUOTE}
  ${MODULE_FRAGMENTS.MARKDOWN_TEXT}
  ${COMPONENT_FRAGMENTS.LIST_ITEM}
  ${MODULE_FRAGMENTS.LIST}

  query GetSplitView($id: String!, $locale: String!) {
    splitView: moduleSplitView(id: $id, locale: $locale) {
      leftContentCollection(limit: 1) {
        items {
          ... on ModuleTileCarousel {
            ...TileCarousel
          }
          ... on ModuleAccordion {
            ...Accordion
          }
          ... on ModuleImage {
            image {
              ...image
            }
            aspectRatio
          }
          ... on ModuleQuote {
            ...Quote
          }
          ... on ModuleMarkdownText {
            ...MarkdownText
          }
        }
      }
      rightContentCollection(limit: 1) {
        items {
          ... on ModuleImage {
            image {
              ...image
            }
            aspectRatio
          }
          ... on ModuleQuote {
            ...Quote
          }
          ... on ModuleMarkdownText {
            ...MarkdownText
          }
          ... on ModuleList {
            ...List
          }
          ... on ModuleAccordion {
            ...Accordion
          }
        }
      }
    }
  }
`;

export const useSplitview = (splitViewId, locale = 'en-US') => {
  const { data, loading, error } = useQuery(GET_SPLIT_VIEW, {
    variables: { id: splitViewId, locale },
    skip: !splitViewId,
  });
  if (error) {
    console.error(error);
  }
  const leftContent = data?.splitView?.leftContentCollection?.items[0] || null;
  const rightContent =
    data?.splitView?.rightContentCollection?.items[0] || null;

  return {
    leftContent,
    rightContent,
    loading,
  };
};
